export const selectCaseListLoading = (store) => store.caseList.loading;
export const selectCaseList = (store) => store.caseList.list;
export const selectCaseErrors = (store) => store.caseList.errors;
export const selectCaseListSize = (store) => store.caseList.listSize;
